var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showError, showSuccess } from '@spike/notifications-action';
import Axios from 'axios';
import { serialize } from 'object-to-formdata';
import { PETS_ACTIVATE_PET_START_ACTION_TYPE, PETS_ACTIVATE_PET_SUCCESS_ACTION_TYPE, PETS_CLEAR_ACTION_TYPE, PETS_DELETE_MEDICAL_CONDITION_START_ACTION_TYPE, PETS_DELETE_MEDICAL_CONDITION_SUCCESS_ACTION_TYPE, PETS_DELETE_START_ACTION_TYPE, PETS_DELETE_SUCCESS_ACTION_TYPE, PETS_DELETE_VACCINE_START_ACTION_TYPE, PETS_DELETE_VACCINE_SUCCESS_ACTION_TYPE, PETS_ERROR_ACTION_TYPE, PETS_FETCH_START_ACTION_TYPE, PETS_FETCH_SUCCESS_ACTION_TYPE, PETS_GET_START_ACTION_TYPE, PETS_GET_SUCCESS_ACTION_TYPE, PETS_MARK_AS_DECEASED_START_ACTION_TYPE, PETS_MARK_AS_DECEASED_SUCCESS_ACTION_TYPE, PETS_POST_NOTE_START_ACTION_TYPE, PETS_POST_NOTE_SUCCESS_ACTION_TYPE, PETS_PRINT_PET_CARD_START_ACTION_TYPE, PETS_PRINT_PET_CARD_SUCCESS_ACTION_TYPE, PETS_RESET_ACTION_TYPE, PETS_SAVE_IMAGE_START_ACTION_TYPE, PETS_SAVE_IMAGE_SUCCESS_ACTION_TYPE, PETS_SAVE_MEDICAL_HISTORY_START_ACTION_TYPE, PETS_SAVE_MEDICAL_HISTORY_SUCCESS_ACTION_TYPE, PETS_SAVE_START_ACTION_TYPE, PETS_SAVE_SUCCESS_ACTION_TYPE, PETS_SAVE_VACCINE_START_ACTION_TYPE, PETS_SAVE_VACCINE_SUCCESS_ACTION_TYPE, PETS_SAVE_VET_ID_START_ACTION_TYPE, PETS_SAVE_VET_ID_SUCCESS_ACTION_TYPE, } from './PetsActionsTypes';
import { convertMedicalHistoryToDto, convertPetVaccineToDto, convertToPet, convertToSaveNoteDto, convertToSavePetDto, } from './PetsConverter';
var fetchPetsByClientUrl = '/get_pets';
var petsUrl = '/pets';
var deceasedPetUrl = '/pet/deceased';
export var clearPetsThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(clear());
            return [2 /*return*/];
        });
    }); };
};
export var fetchPetsThunk = function (apiClientWrapper, clientId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(fetchPetsByClientUrl, "?marketplace_id=").concat(marketplaceId, "&customer_id=").concat(clientId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        dispatch(error());
                        dispatch(showError('Error fetching pets.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getPetThunk = function (apiClientWrapper, petId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        dispatch(showError('Error getting pets.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var savePetThunk = function (apiClientWrapper, pet) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, actualPet, getUrl, getResponse, apiMethod, saveUrl, petRequest, formData, options, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(savePetStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    actualPet = void 0;
                    if (!pet.id) return [3 /*break*/, 3];
                    getUrl = "".concat(petsUrl, "/").concat(pet.id, "?marketplace_id=").concat(marketplaceId);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(getUrl, apiClientWrapper.requestConfig)];
                case 2:
                    getResponse = _a.sent();
                    actualPet = convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, getResponse.data);
                    _a.label = 3;
                case 3:
                    apiMethod = pet.id ? apiClientWrapper.apiClient.patch : apiClientWrapper.apiClient.post;
                    saveUrl = pet.id
                        ? "".concat(petsUrl, "/").concat(pet.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(petsUrl, "?marketplace_id=").concat(marketplaceId);
                    petRequest = convertToSavePetDto(apiClientWrapper.marketplaceId, pet, actualPet);
                    if (pet.id) {
                        petRequest.owns_attributes = undefined;
                    }
                    if (pet.birthdate === undefined) {
                        petRequest.birthdate = null;
                    }
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: false,
                    };
                    formData = serialize(petRequest, options, formData, 'pet');
                    if (pet.positivePersonalities && pet.positivePersonalities.length === 0) {
                        formData.append('pet[positive_personality_list][]', '');
                    }
                    if (pet.negativePersonalities && pet.negativePersonalities.length === 0) {
                        formData.append('pet[negative_personality_list][]', '');
                    }
                    return [4 /*yield*/, apiMethod(saveUrl, formData, apiClientWrapper.multipartRequestConfig)];
                case 4:
                    response = _a.sent();
                    dispatch(savePetSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone));
                    dispatch(showSuccess('Update pet successfully'));
                    return [3 /*break*/, 6];
                case 5:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        dispatch(showError('Error updating pet'));
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var saveImageThunk = function (apiClientWrapper, petId, imageFile) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, request, formData, options, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveImageStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    request = {
                        id: petId,
                        marketplace_id: marketplaceId,
                        image: imageFile !== null && imageFile !== void 0 ? imageFile : new Blob(),
                        remove_image: imageFile === undefined,
                    };
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: false,
                    };
                    formData = serialize(request, options, formData, 'pet');
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, formData, apiClientWrapper.multipartRequestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveImageSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone));
                    dispatch(showSuccess('Image updated'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        dispatch(showError('Error updating image'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveMedicalHistoryThunk = function (apiClientWrapper, petId, medicalHistory, vetId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, getResponse, currentPet, request, formData, options, responseUpdate, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveMedicalHistoryStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    getResponse = _a.sent();
                    currentPet = convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, getResponse.data);
                    request = convertMedicalHistoryToDto(apiClientWrapper.marketplaceId, currentPet, medicalHistory);
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: false,
                    };
                    formData = serialize(request, options, formData, 'pet');
                    if (vetId === null) {
                        formData.append('pet[vet_id]', '');
                    }
                    else if (vetId !== undefined) {
                        formData.append('pet[vet_id]', vetId.toString());
                    }
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, formData, apiClientWrapper.multipartRequestConfig)];
                case 3:
                    responseUpdate = _a.sent();
                    dispatch(saveMedicalHistorySuccess(convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, responseUpdate.data)));
                    dispatch(showSuccess('Update medical history successfully.'));
                    return [3 /*break*/, 5];
                case 4:
                    apiError_5 = _a.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        console.error(apiError_5);
                        dispatch(error());
                        dispatch(showError('Error saving medical history.'));
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var saveVetIdThunk = function (apiClientWrapper, petId, vetId, showAlert) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, request, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveVetIdStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    request = { vet_id: vetId };
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, request, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveVetIdSuccess(convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, response.data)));
                    showAlert && dispatch(showSuccess("Vet saved."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!Axios.isCancel(apiError_6)) {
                        dispatch(error());
                        dispatch(showError("Error saving pet's vet."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var postNoteThunk = function (apiClientWrapper, petId, note) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, request, response, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(postNoteStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    request = {
                        id: petId,
                        marketplace_id: marketplaceId,
                        notes_attributes: [convertToSaveNoteDto(note)],
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, request, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(postNoteSuccess(convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    if (!Axios.isCancel(apiError_7)) {
                        dispatch(error());
                        dispatch(showError('Error posting pet note.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveVaccineThunk = function (apiClientWrapper, petId, vaccine) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, request, formData, options, response, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveVaccineStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    request = {
                        id: petId,
                        marketplace_id: marketplaceId,
                        pet_vaccine_expirations_attributes: [convertPetVaccineToDto(marketplaceId, vaccine, petId)],
                    };
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: false,
                    };
                    formData = serialize(request, options, formData, 'pet');
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, formData, apiClientWrapper.multipartRequestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveVaccineSuccess(convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    if (!Axios.isCancel(apiError_8)) {
                        dispatch(error());
                        dispatch(showError('Error saving vaccine.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteVaccineThunk = function (apiClientWrapper, petId, vaccineId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, request, response, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteVaccineStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    request = {
                        id: petId,
                        marketplace_id: marketplaceId,
                        pet_vaccine_expirations_attributes: [{ id: vaccineId, _destroy: true }],
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, request, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(deleteVaccineSuccess(convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _a.sent();
                    if (!Axios.isCancel(apiError_9)) {
                        dispatch(error());
                        dispatch(showError('Error deleting vaccine.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteMedicalConditionThunk = function (apiClientWrapper, petId, medicalConditionRecordId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, request, response, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteMedicalConditionStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    request = {
                        id: petId,
                        marketplace_id: marketplaceId,
                        pet_conditions_attributes: [{ id: medicalConditionRecordId, _destroy: true }],
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, request, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(deleteMedicalConditionSuccess(convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    if (!Axios.isCancel(apiError_10)) {
                        dispatch(error());
                        dispatch(showError('Error deleting medical condition.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deletePetThunk = function (apiClientWrapper, petId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiError_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId, "&pet[deleted]=true");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteSuccess(petId));
                    dispatch(showSuccess('Pet deleted successfully.'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_11 = _a.sent();
                    if (!Axios.isCancel(apiError_11)) {
                        dispatch(error());
                        dispatch(showError('Error deleting pet.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var markPetAsDeceasedThunk = function (apiClientWrapper, petId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(markAsDeceasedStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(deceasedPetUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, {
                            marketplace_id: marketplaceId,
                        }, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(markAsDeceasedSuccess(convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, response.data.pet)));
                    dispatch(showSuccess("Pet disabled successfully, (".concat(response.data.total_appt_cancelled, ") appointments cancelled and (").concat(response.data.total_appt_to_pay, ") with pending payment.")));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_12 = _a.sent();
                    if (!Axios.isCancel(apiError_12)) {
                        dispatch(error());
                        dispatch(showError('Error disabling pet.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var activatePetThunk = function (apiClientWrapper, petId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, request, response, apiError_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(activatePetStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(petsUrl, "/").concat(petId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    request = {
                        id: petId,
                        marketplace_id: marketplaceId,
                        active: true,
                        deceased: false,
                    };
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, request, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(activatePetSuccess(convertToPet(apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone, response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_13 = _a.sent();
                    if (!Axios.isCancel(apiError_13)) {
                        dispatch(error());
                        dispatch(showError('Error activating pet.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var printPetCardPDFThunk = function (apiClientWrapper, petId, isMobile, printOptions) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, body, response, pdfBlob, blobUrl_1, link, iframe_1, apiError_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(printPetCardStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "/pet/".concat(petId, "/download?marketplace_id=").concat(marketplaceId);
                    body = {
                        printOptions: printOptions
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, body, __assign(__assign({}, apiClientWrapper.requestConfig), { responseType: 'blob' }))];
                case 2:
                    response = _a.sent();
                    pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                    blobUrl_1 = window.URL.createObjectURL(pdfBlob);
                    if (isMobile) {
                        link = document.createElement('a');
                        link.href = blobUrl_1;
                        link.download = 'pet_card.pdf';
                        link.click();
                    }
                    else {
                        iframe_1 = document.createElement('iframe');
                        iframe_1.style.display = 'none';
                        iframe_1.id = 'printPetCard';
                        iframe_1.src = blobUrl_1;
                        iframe_1.onload = function () {
                            if (iframe_1.contentWindow) {
                                iframe_1.contentWindow.focus();
                                iframe_1.contentWindow.print();
                                iframe_1.contentWindow.onafterprint = function () {
                                    document.body.removeChild(iframe_1);
                                    window.URL.revokeObjectURL(blobUrl_1);
                                };
                            }
                        };
                        document.body.appendChild(iframe_1);
                    }
                    dispatch(printPetCardSuccess());
                    return [3 /*break*/, 4];
                case 3:
                    apiError_14 = _a.sent();
                    if (!Axios.isCancel(apiError_14)) {
                        dispatch(error());
                        dispatch(showError('Error printing pet card.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: PETS_RESET_ACTION_TYPE,
    };
};
var clear = function () {
    return {
        type: PETS_CLEAR_ACTION_TYPE,
    };
};
var fetchStart = function () {
    return {
        type: PETS_FETCH_START_ACTION_TYPE,
    };
};
export var fetchSuccess = function (petsDto, masterData, marketplace, timeZone) {
    return {
        type: PETS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            pets: petsDto.map(function (petDto) { return convertToPet(masterData, marketplace, timeZone, petDto); }),
        },
    };
};
var getStart = function () {
    return {
        type: PETS_GET_START_ACTION_TYPE,
    };
};
export var getSuccess = function (petDto, masterData, marketplace, timeZone) {
    return {
        type: PETS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            pet: convertToPet(masterData, marketplace, timeZone, petDto),
        },
    };
};
var saveMedicalHistoryStart = function () {
    return {
        type: PETS_SAVE_MEDICAL_HISTORY_START_ACTION_TYPE,
    };
};
var saveMedicalHistorySuccess = function (pet) {
    return {
        type: PETS_SAVE_MEDICAL_HISTORY_SUCCESS_ACTION_TYPE,
        payload: {
            pet: pet,
        },
    };
};
var saveVetIdStart = function () {
    return {
        type: PETS_SAVE_VET_ID_START_ACTION_TYPE,
    };
};
var saveVetIdSuccess = function (pet) {
    return {
        type: PETS_SAVE_VET_ID_SUCCESS_ACTION_TYPE,
        payload: {
            pet: pet,
        },
    };
};
var savePetStart = function () {
    return {
        type: PETS_SAVE_START_ACTION_TYPE,
    };
};
export var savePetSuccess = function (petDto, masterData, marketplace, timeZone) {
    return {
        type: PETS_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            pet: convertToPet(masterData, marketplace, timeZone, petDto),
        },
    };
};
var saveImageStart = function () {
    return {
        type: PETS_SAVE_IMAGE_START_ACTION_TYPE,
    };
};
var saveImageSuccess = function (petDto, masterData, marketplace, timeZone) {
    return {
        type: PETS_SAVE_IMAGE_SUCCESS_ACTION_TYPE,
        payload: {
            pet: convertToPet(masterData, marketplace, timeZone, petDto),
        },
    };
};
var postNoteStart = function () {
    return {
        type: PETS_POST_NOTE_START_ACTION_TYPE,
    };
};
var postNoteSuccess = function (pet) {
    return {
        type: PETS_POST_NOTE_SUCCESS_ACTION_TYPE,
        payload: {
            pet: pet,
        },
    };
};
var saveVaccineStart = function () {
    return {
        type: PETS_SAVE_VACCINE_START_ACTION_TYPE,
    };
};
var saveVaccineSuccess = function (pet) {
    return {
        type: PETS_SAVE_VACCINE_SUCCESS_ACTION_TYPE,
        payload: {
            pet: pet,
        },
    };
};
var deleteVaccineStart = function () {
    return {
        type: PETS_DELETE_VACCINE_START_ACTION_TYPE,
    };
};
var deleteVaccineSuccess = function (pet) {
    return {
        type: PETS_DELETE_VACCINE_SUCCESS_ACTION_TYPE,
        payload: {
            pet: pet,
        },
    };
};
var deleteMedicalConditionStart = function () {
    return {
        type: PETS_DELETE_MEDICAL_CONDITION_START_ACTION_TYPE,
    };
};
var deleteMedicalConditionSuccess = function (pet) {
    return {
        type: PETS_DELETE_MEDICAL_CONDITION_SUCCESS_ACTION_TYPE,
        payload: {
            pet: pet,
        },
    };
};
var activatePetStart = function () {
    return {
        type: PETS_ACTIVATE_PET_START_ACTION_TYPE,
    };
};
var activatePetSuccess = function (pet) {
    return {
        type: PETS_ACTIVATE_PET_SUCCESS_ACTION_TYPE,
        payload: {
            pet: pet,
        },
    };
};
var markAsDeceasedStart = function () {
    return {
        type: PETS_MARK_AS_DECEASED_START_ACTION_TYPE,
    };
};
var markAsDeceasedSuccess = function (pet) {
    return {
        type: PETS_MARK_AS_DECEASED_SUCCESS_ACTION_TYPE,
        payload: {
            pet: pet,
        },
    };
};
export var deleteStart = function () {
    return {
        type: PETS_DELETE_START_ACTION_TYPE,
    };
};
export var deleteSuccess = function (petId) {
    return {
        type: PETS_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            petId: petId,
        },
    };
};
var printPetCardStart = function () {
    return {
        type: PETS_PRINT_PET_CARD_START_ACTION_TYPE,
    };
};
var printPetCardSuccess = function () {
    return {
        type: PETS_PRINT_PET_CARD_SUCCESS_ACTION_TYPE,
    };
};
var error = function () {
    return {
        type: PETS_ERROR_ACTION_TYPE,
    };
};
